<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="分类名称" prop="categoryId" >
        <a-select v-model="form.categoryId">
          <a-select-option v-for="item in categoryList" :value="item.id">{{item.categoryName}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="森林名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入森林名称" />
      </a-form-model-item>
      <a-form-model-item label="森林描述" prop="descr" >
        <a-input v-model="form.descr" placeholder="请输入森林名称" />
      </a-form-model-item>

      <a-form-model-item label="封面" prop="coverImg" >
        <file-upload type="image" :defaultList="form.coverImgArr" :count="1"
                     @input="getImg($event, 'coverImg')"></file-upload>
      </a-form-model-item>
      <a-form-model-item label="时间树" prop="treeTimeId" >
        <a-select v-model="form.treeTimeId">
          <a-select-option v-for="item in timeTreeList" :value="item.id">{{item.title}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="背景图" prop="bgImg" >
        <file-upload type="image" :defaultList="form.bgImgArr" :count="1"
                     @input="getImg($event, 'bgImg')"></file-upload>
      </a-form-model-item>

      <a-form-model-item label="关联森林" prop="linkForest" >
        <a-select v-model="form.linkForest"  mode="multiple">
          <a-select-option v-for="item in forestList" :value="item.id">{{item.name}}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="森林等级" prop="levelId" >
        <a-select v-model="form.levelId">
          <a-select-option v-for="item in levelList" :value="item.id">{{item.name}} - {{item.growthValue}}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="成长值" prop="growthValue" >
        <a-input-number style="width: 300px" :min="0"  v-model="form.growthValue" placeholder="请输入成长值" />
      </a-form-model-item>

      <a-form-model-item label="是否置顶" prop="isTop" >
        <a-select v-model="form.isTop">
          <a-select-option :value="0">否</a-select-option>
          <a-select-option :value="1">是</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="是否推荐" prop="isRecommend" >
        <a-select v-model="form.isRecommend">
          <a-select-option :value="0">否</a-select-option>
          <a-select-option :value="1">是</a-select-option>
        </a-select>
      </a-form-model-item>
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getForest, addForest, updateForest,listForest } from '@/api/forest/forest'
import {listCategory} from "@/api/forest/category";
import {guid} from "@/utils/ruoyi";
import {listTime} from "@/api/tree/time";
import {listLevel} from "@/api/forest/level";
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      categoryList:[],
      timeTreeList:[],
      forestList:[],
      levelList:[],
      // 表单参数
      form: {
        id: null,

        categoryId: null,

        name: null,
        descr:null,
        coverImg: null,
        coverImgArr:[],
        coverImgCount:0,
        treeTimeId: null,
        linkForest:[],
        bgImg: null,
        bgImgArr:[],
        bgImgCount:0,
        treeFriends: null,
        levelId:null,
        growthValue:null,
        isTop: null,
        isRecommend: null,
        createTime: null,
        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        categoryId: [
          { required: true, message: '分类名称不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '森林名称不能为空', trigger: 'blur' }
        ],
        // coverImg: [
        //   { required: true, message: '封面图不能为空', trigger: 'blur' }
        // ],
        // bgImg: [
        //   { required: true, message: '背景图不能为空', trigger: 'blur' }
        // ]
      }
    }
  },
  filters: {
  },
  created () {
    this.initCategory()
  },
  activated() {
    this.initCategory()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        categoryId: null,
        name: null,
        descr:null,
        coverImgArr:[],
        coverImgCount:0,
        treeTimeId: null,
        linkForest:[],
        bgImg: null,
        bgImgArr:[],
        bgImgCount:0,
        treeFriends: null,
        isTop: null,
        levelId:null,
        growthValue:null,
        isRecommend: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },

    initCategory(){
      listCategory().then(res=>{
        this.categoryList = res.data
      })
      listTime().then(res=>{
        this.timeTreeList = res.data
      })
      listLevel().then(res=>{
        this.levelList = res.data
      })
    },
    initForest(id){
      listForest({id:id}).then(res=>{
        this.forestList = res.data
      })
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },

    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      this.initForest()
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      this.initForest(id)
      getForest({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
        let that = this;
        if(this.form.coverImg){
          this.form.coverImgArr = []
          this.form.coverImgArr.push({
            uid: guid(8, 10),
            name: that.form.coverImg,
            status: 'done',
            halfUrl: that.form.coverImg,
            url: that.form.coverImg,
            path: that.form.coverImg
          })
        }
        if(this.form.bgImg){
          this.form.bgImgArr = []
          this.form.bgImgArr.push({
            uid: guid(8, 10),
            name: that.form.bgImg,
            status: 'done',
            halfUrl: that.form.bgImg,
            url: that.form.bgImg,
            path: that.form.bgImg
          })
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateForest(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addForest(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
